import { View } from 'react-native';
import { COLOR, FONT_SIZE } from 'constants/design-system';

import { BaseText } from 'components/BaseText';

import type { ViewProps } from 'react-native';

export type FinancialInfoCardItemProps = {
  label: string;
  value: string;
  hide?: boolean;
} & Pick<ViewProps, 'style'>;

export const FinancialInfoCardItem = (props: FinancialInfoCardItemProps) => {
  const { label, value, style, hide } = props;
  return (
    <View style={style}>
      <BaseText color={COLOR.theme.gray[500]} fontSize={FONT_SIZE.theme.xs}>
        {!hide && label.toUpperCase()}
      </BaseText>
      <BaseText color={COLOR.theme.white} fontSize={FONT_SIZE.theme.base}>
        {!hide && value}
      </BaseText>
    </View>
  );
};
